const getInitialTouched = () => {
    // Because the donor account form never loads in saved values all of the
    // fields should not be touched when the form is loaded on to the page
    const touched = {};

    return touched;
};

export default getInitialTouched;
